

import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { ScreenEvent } from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import { WinWaysCounter } from "./WinWaysCounter";
import { StageEvent } from "@nolimitcity/slot-game/bin/core/stage/event/StageEvent";
import { ServerEvent } from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { GameMode } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import { PunkParsedGameData } from "../../../server/data/PunkParsedGameData";
import { PunkGameConfig } from "../../../PunkGameConfig";
import { NormalWinCountUp } from "../../features/win/normal/NormalWinCountUp";
import { BigWinCountUp } from "../../features/win/bigwin/BigWinCountUp";
export class WinCounter {

    private static xOffset:number = 0;

    private static Initiated:boolean = false;

    // private static _fsCounter:FSCounter;
    private static _bigwinCunter:BigWinCountUp;
    private static _winWayCounter:WinWaysCounter;
    private static _normalCounter:NormalWinCountUp;

    public static get bigwinCounter():BigWinCountUp{ return this._bigwinCunter; }
    public static get winWayCounter():WinWaysCounter{ return this._winWayCounter; }
    public static get normalCounter():NormalWinCountUp{ return this._normalCounter; }

    constructor() {
        EventHandler.addEventListener(this, ScreenEvent.GAME_READY, () =>  WinCounter.initCounters());
        EventHandler.addEventListener(this, StageEvent.STAGE_RESIZED, () => WinCounter.newMidPos());
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => WinCounter.newMidPos(event.params[0]));
    }

    protected static initCounters():void{

        this._bigwinCunter = new BigWinCountUp();
        this._winWayCounter = new WinWaysCounter();
        this._normalCounter = new NormalWinCountUp();

        StageManager.getLayer(PunkGameConfig.instance.LAYERS.WIN_COUNT_UP.name).sortChildren();
        this.Initiated = true;
    }

    public static newMidPos(data?:PunkParsedGameData):void{
        if(!this.Initiated) return;
        if(data) this.xOffset = data.mode != GameMode.NORMAL ? 10: 0;
        
        this._winWayCounter.onResize(this.xOffset)
        this._normalCounter.onResize(this.xOffset)
        this._bigwinCunter.onResize(this.xOffset)
    }
}